<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woreportrecord/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('shebeimingcheng')">
            <el-input disabled v-model="$attrs.reportWork.equipment.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('caozuoyonghu')">
            <el-input disabled v-model="$attrs.reportWork.operator.nickname"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('tibaoshijianqujian')">
            <el-input disabled v-model="reportTimeRange" style="width: 260px">
            </el-input>
          </el-form-item>

          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #shifoubulu="scope">
        {{scope.row.type == 0 ? $t('fou') : $t('shi')}}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baogongjilu', scope.row,'w2')">
              {{$t('baogongjilu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>

</template>
<script type="text/javascript">
  // import work_bom from '@@/pages/web/order_management/erp/work_bom'
  export default {
    props: ['chart'],
    name: 'web_production_management_equipment_operation_record',
    components: {
      // work_bom
    },
    data() {
      return {
        chartHeight: '',
        reportTimeRange: '',
        woIds: '',
        showMode: 'list',
        progresses: [],
        gridFlowHeights: {},
        editConditions: {
          priority: ''
        },
        drawer: false,
        direction: 'btt',
        addDrawer: false,
        updateDrawer: false,
        graph: null,
        currentNode: null,
        selectParentIds: null,
        priority: null,
        routeList: [],
        nodeList: [],
        flows: [],
        columns: [
          {
            label: 'shengchangongdanhao',
            prop: 'productionNo',
            width: 130
          },
          {
            label: 'ERPgongdanhao',
            prop: 'erpNo',
            width: 130
          },
          {
            label: 'shebeimingcheng',
            prop: 'equipmentName'
          },
          {
            label: 'mujubianhao',
            prop: 'mouldNo'
          },
          {
            label: 'mujumingcheng',
            prop: 'mouldName'
          },
          {
            label: 'chanpinbianma',
            prop: 'materialCode'
          },
          {
            label: 'chanpinmingcheng',
            prop: 'materialName'
          },{
            label: 'gongxugongdan',
            prop: 'procedureNo'
          },{
            label: 'gongxumiaoshu',
            prop: 'procedureDesc'
          },{
            label: 'baogongshuliang',
            prop: 'quantity',
          },{
            label: 'buliangshuliang',
            prop: 'badQuantity',
          },{
            label: 'baogongriqi',
            prop: 'reportDate',
            format: "YYYY-MM-DD",
            type: 'time',
            width: 150,
          },{
            label: 'baogongbanci',
            prop: 'shiftName',
            width: 150,
          },{
            label: 'tibaoshijian',
            prop: 'createTime',
            type: 'time',
            width: 150,
          },{
            label: 'caozuoren',
            prop: 'createByObject.nickname',
          },{
            label: 'beizhu',
            prop: 'remark',
          }
        ]
      };
    },
    mounted() {
    },
    created() {
      setTimeout(() => {

        this.yt.conditions = {
          equipmentIds:this.$attrs.reportWork.equipmentId,
          operator:this.$attrs.reportWork.operator.nickname,
          createTimeStart: this.$attrs.reportWork.startTime,
          createTimeEnd: this.$attrs.reportWork.endTime,

        }
        this.yt.get(1)
        this.reportTimeRange = this.formatDateTimeRange(this.$attrs.reportWork.startTime, this.$attrs.reportWork.endTime)
      }, 300)
    },
    methods: {
      formatDateTimeRange(startTime, endTime) {
        if (!startTime || !endTime) return '';

        const start = new Date(startTime).toLocaleString();
        const end = new Date(endTime).toLocaleString();

        return `${start} 至 ${end}`;
      }
    }
  };
</script>

